import { TaskDao } from '@rock/db-admin';
import type { HomeId, HomeTaskSubscriptionId, TaskId, TaskStatus } from '@rock/types';
import { shallowEqual } from '@rock/util';
import { atomFamily } from 'jotai/utils';

const taskDao = new TaskDao();

export const tasksForSubscriptionState = atomFamily(
    (params: { homeId: HomeId | null; subscriptionId: HomeTaskSubscriptionId | undefined }) =>
        taskDao.tasksForSubscriptionAtom(params.homeId, params.subscriptionId),
    shallowEqual,
);

/** Bounded, optionally status-filtered task list for a home — the tasks collection grows forever. */
export const tasksForHomeState = atomFamily(
    (params: { homeId: HomeId | null; status: TaskStatus | undefined; limit: number }) =>
        taskDao.tasksForHomeAtom(params.homeId, params.status, params.limit),
    shallowEqual,
);

export const taskState = atomFamily(
    (params: { homeId: HomeId; taskId: TaskId }) => taskDao.taskAtom(params.homeId, params.taskId),
    shallowEqual,
);
